import { Chartisan, ChartisanHooks } from "@chartisan/chartjs";

const concreteOptions = {
    'pass_counter': {
        hooks: new ChartisanHooks()
            .beginAtZero()
            .colors(),
    },
    'pass_channel': {
        hooks: new ChartisanHooks()
            .legend({ position: 'right' })
            .datasets('doughnut')
            .pieColors(),
    },
    'user_negative_balance': {
        hooks: new ChartisanHooks()
            .legend(false)
            .beginAtZero(),
    },
    'alert_unnumber': {
        hooks: new ChartisanHooks()
            .legend(false)
            .beginAtZero(),
    },
    'alert_unpass': {
        hooks: new ChartisanHooks()
            .legend(false)
            .beginAtZero(),
    },
    'alert_editable': {
        hooks: new ChartisanHooks()
            .legend(false)
            .beginAtZero(),
    },
};

window.initChart = function (name, block, endpoint) {
    block.innerHTML = '';
    const options = concreteOptions[name] || {};

    const chart = new Chartisan({
        el: block,
        url: endpoint,
        hooks: new ChartisanHooks().colors(),
        ...options,
    });

    return {
        updateChart({ chart: chartName, endpoint }) {
            if (chartName !== name) {
                console.log(chartName, name)
                return;
            }

            chart.update({url: endpoint});
        },
    };
};
